import React, { useState } from 'react'
import styles from './Log_in.module.css'

const Log_in = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmed, setConfirmed] = useState('')

  const register = () => {
    fetch('http://englishtutorial1.somee.com/api/Account/Register', {
      method: "POST",
      headers: {
        "Content-Type": "application/json, text/json"
      },
      body: JSON.stringify({
        "Email": email,
        "Password": password,
        "ConfirmPassword": confirmed
      })
    })
  }
  return (
    <div className={styles.flex}>
      <div className={styles.flexItem}>
        <label >Email:</label>
        <input type="email" placeHolder="Write Email" value={email} onChange={e => setEmail(e.target.value)} className={styles.input} />
        <label >Password:</label>
        <input type="password" placeHolder="Write Password" value={password} onChange={e => setPassword(e.target.value)} className={styles.input} />
        <button onClick={register} className={styles.btn}>Sign in</button>
      </div>
    </div>
  )
}

export default Log_in
